import { render, staticRenderFns } from "./ModalFullImageViewer.vue?vue&type=template&id=f71fbb4a&"
import script from "./ModalFullImageViewer.vue?vue&type=script&lang=ts&"
export * from "./ModalFullImageViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports